import { render, staticRenderFns } from "./Model20.vue?vue&type=template&id=ed5e4fae&scoped=true"
import script from "./Model20.vue?vue&type=script&lang=js"
export * from "./Model20.vue?vue&type=script&lang=js"
import style0 from "./Model20.vue?vue&type=style&index=0&id=ed5e4fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5e4fae",
  null
  
)

export default component.exports